import request from "root/js/request";

export const getSharesProductsHistoryExport = async ({ cabinet_id, shares_id }) => {
  const response = await request({
    url: `analytics/shares_log/export/?cabinet_id=${cabinet_id}&shares_id=${shares_id}`,
    method: "get",
  });
  return response.data;
};
